<template>
    <div>
        <v-card class="score-chart ma-1">
            <v-container>
                <v-card-title>
                    <span class="caption-font white--text"><v-avatar size="40" class="change mr-4"><v-icon color="white">mdi-help</v-icon></v-avatar>Host requests</span>
                </v-card-title>
                <span class="br_medium"></span>
                <v-row class="white--text ml-4 mb-6">
                    <table style="width:80%">
                        <tr v-for="change in changeRequests" :key="change.key">
                            <td class="td_markup_xl">{{ change.text }}</td>
                            <td style="text-align: right;" class="td_markup_xl">{{ change.num }}</td>
                            <td style="text-align: right;" class="td_markup_xl">
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon v-on:click="openSubScreen(change.path)">
                                        <v-icon>mdi-open-in-app</v-icon>
                                    </v-btn>
                                </template>
                                <span style="text-align: right;">{{ change.path_tooltip }}</span>
                            </v-tooltip>
                            </td>
                        </tr>
                    </table>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
    import { bus } from "../../../../main";

    export default {
        props: {
            gebr: {
                type: Object,
                default: () => ({}),
            }
        },
        components: {
        },
        data() {
            return {
                changeRequests: [],
            }
        },
        created() {
            this.getWzvzOverview();
            bus.$on("refresh", (data) => {
                console.log("refresh received for changes " + data);
                this.getWzvzOverview();
            });
        },
        methods: {
            openSubScreen(path) {
                let route = this.$router.resolve({ path: path }); 
                window.open(route.href, '_blank');

            },
            getWzvzOverview() {
                this.$axios.post("ares/json/ares/syst/dashboard/getWzvzOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getWzvzOverview"
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.changeRequests = res.data.getWzvzOverview;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .score-chart {
        background-image: linear-gradient(#8F00CE, #D6A1ED) !important;
        background-size: cover !important;
    }

    .br_medium {
        display: block;
        margin-bottom: 1em;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .td_markup_xl {
        font-size: 17px !important;
        line-height: 25px !important;
    }
    .change {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid white;
        color: white;
        cursor: default;
    }
</style>